import React from "react";
import useMe from "@/hooks/useMe";
import AddCollectionIcon from "@/components/ui/collection/add-collection-icon";
import ImageCard from "@/components/core/image-card";
import useCollection from "@/hooks/useCollection";
import useSnackbar from "@/hooks/useSnackbar";

interface WebCarouselProps {}

const WebCarousel: React.FC<WebCarouselProps> = () => {
  const { fetchMe } = useMe();
  const { setShowDrawer, saveItem, collections } = useCollection();
  const { showSnackbar } = useSnackbar();

  const collectionCoverImages = (collection: any) => {
    return collection.items.slice(0, 4).map((item: any) => item.thumbnailImage);
  };

  const handleSave = async (collection: any) => {
    if (!collection.id) {
      return;
    }
    saveItem({
      collection,
      onSuccess: () => {
        showSnackbar(`Item added to "${collection.name}"`);
        setShowDrawer(false);
        fetchMe();
      },
    });
  };

  const onCreateCollectionSuccess = (collection: any) => {
    handleSave(collection);
  };

  if (collections.length === 0) {
    return <></>;
  }

  return (
    <>
      <div className="collection-mobile-list">
        {collections.map((collection: any) => {
          return (
            <div key={collection.id} className="collection">
              <div
                className="collection-image"
                style={{
                  cursor: !collection.id ? "default" : "pointer",
                }}
                onClick={() => handleSave(collection)}
              >
                <ImageCard images={collectionCoverImages(collection)} />
              </div>
              <div className="collection-name">{collection.name}</div>
              <div className="collection-items-number">
                {collection.items.length} items
              </div>
            </div>
          );
        })}
        <div className="collection">
          <AddCollectionIcon
            style={{ aspectRatio: 1 }}
            // @ts-expect-error ignore
            onSuccess={onCreateCollectionSuccess}
          />
          <div className="collection-name create-collection">
            Create new collection
          </div>
          <div className="collection-items-number"></div>
        </div>
      </div>
      <style jsx>{`
        .collection-mobile-list {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          .collection {
            display: flex;
            flex-direction: column;
            width: calc(calc(100% - 12px) / 2);
            margin-bottom: 36px;

            .collection-image {
              object-fit: cover;
              object-position: center bottom;
              aspect-ratio: 1;
              cursor: pointer;
            }

            .collection-name {
              color: #191919;
              font-size: 16px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
              letter-spacing: -0.32px;
              margin-top: 16px;
              text-align: left;
              max-height: 57px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              -webkit-font-smoothing: antialiased;
              -moz-osx-font-smoothing: grayscale;
              font-smooth: never;
              flex-shrink: 0;

              &.create-collection {
                color: #999;
              }
            }

            .collection-items-number {
              color: #666;
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
              letter-spacing: -0.28px;
              margin-top: 4px;
              height: 17px;
              flex-shrink: 0;
            }
          }
        }
      `}</style>
    </>
  );
};

export default WebCarousel;
